export const COMPARISON_PERIODS = [
 {id:'year',label:'Ein Jahr · November 2024 bis November 2025',from:'2024-11-01',to:'2025-11-01'},
 {id:'six_years',label:'Sechs Jahre · Januar 2024 bis Januar 2030',from:'2024-01-01',to:'2030-01-01'},
];
export function energyValue(kwh:number, settings:any) {
 if(settings?.electricity_price_ct_kwh==null)return null;
 const share=settings.self_consumption_percent/100;
 return kwh*(share*settings.electricity_price_ct_kwh+(1-share)*settings.export_price_ct_kwh)/100;
}
/** Same scene, weather settings and module count for each pair. Never extrapolate. */
export async function runUpgradeComparison(run:(period:any,mode:'fixed'|'tracking')=>Promise<any>) {
 const comparisons=[];
 for(const period of COMPARISON_PERIODS) {
  const fixed=await run(period,'fixed'),tracking=await run(period,'tracking');
  comparisons.push({...period,fixed,tracking});
 }
 return {comparisons,source:'rayalign_simulation_estimate',method:'same_scene_fixed_vs_tracking',
  assumptions:'Konstante Wetter-, Verlust- und Preisannahmen. Keine gemessenen Erträge, keine Wetter- oder Preisprognose. Keine Degradation oder Investitionskosten berücksichtigt.'};
}
